import { render, staticRenderFns } from "./FePruebas.vue?vue&type=template&id=10511bc0&"
import script from "./FePruebas.vue?vue&type=script&lang=js&"
export * from "./FePruebas.vue?vue&type=script&lang=js&"
import style0 from "./FePruebas.vue?vue&type=style&index=0&id=10511bc0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports